<template>
  <div>
    <!-- (正式且商户762)||(测试且166)展示6.4.0的新的配置页-->
    <newConfig v-if="(config.IsOfficial&&mallInfo.MallId==762)||(!config.IsOfficial&&mallInfo.MallId==166)"></newConfig>
    <agentConfig v-else></agentConfig>
  </div>
</template>

<script>
import agentConfig from './agentConfig'
import newConfig from './newConfig'
import {
  mapGetters
} from 'vuex'
import config from "@/config"
export default {
  components: {
    agentConfig,
    newConfig
  },
  computed: {
    ...mapGetters([
      'mallInfo'
    ]),
  },
  data () {
    return {
      config:config
    }
  },
  mounted () {
    console.log(config.IsOfficial, this.mallInfo.MallId)
  }
}
</script>

<style lang='less' scoped>

</style>